namespace advisorop.components.common {
    
    class UserProfileController {

        public $router;

        static $inject = ["identityService"];
        constructor(public identityService: services.IdentityService) {

        }

        logout(): void {
            this.identityService.logout();
        }

        $onInit(): void {
        }

        $routerOnActivate(next, previous) {
        }
    }



    class UserProfile implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {               
                $router: "<"
            };
            this.controller = UserProfileController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/shared/common/user-profile.html';
        }
    }
    angular.module(Constants.APP).component("userProfile", new UserProfile());


}